import React from 'react';

import ChimeSdkWrapper from '../lib/chime';

const context = React.createContext<ChimeSdkWrapper>(new ChimeSdkWrapper());

export default context;
